import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';

import { SPORT, CLEAR_SPORT } from 'actions/sports';

const INITIAL_STATE = Immutable({
  loading: false,
  data: {},
  error: null,
});

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case `${SPORT}_LOADING`:
      return state.merge({ loading: true, error: null });
    case `${SPORT}_ERROR`:
      return state.merge({
        loading: false,
        error: action.payload,
      });
    case `${SPORT}`:
      return state.merge(
        {
          loading: false,
          data: { [action.meta.id]: action.payload },
          error: null,
        },
        { deep: true },
      );
    case CLEAR_SPORT:
      return state.merge({
        loading: false,
        data: {},
        error: null,
      });
    default:
      return state;
  }
};
